/* ============================================================
   HERZ DER KARTEN – hdk-util.js
   Reine Funktionen (kein DOM, kein Netzwerk, kein Zustand), die
   mehrere Theme-Skripte teilen — und die als EINZIGE Theme-Logik
   ohne Browser testbar sind: `node --test scripts/unit/*.test.js`
   (die Verzeichnisform `scripts/unit/` bricht unter Node 24 ab).

   INHALT — alle Funktionen haben Aufrufer (Stand 2026-10-05, Audit M2
   Block A; vorher lagen sie als Inline-Kopien in den Modulen):
     tierMinQty, parseTierMoney   Dealeasy-Bridge (product-page.js)
     chfAusRappen                 Versandbalken, Sticky, GradedGuard
     chfAusFranken                Suchvorschlaege (search-suggest.js)
     escapeHTML                   innerHTML-Schutz
     normalizeQty                 Mengenfelder Drawer + /cart
     versandStand                 Versandbalken Produktseite + Sticky,
                                  GradedGuard
     versandBand, tierFor         GradedGuard (Versandvorschau, Staffel)
     kaufbareMenge                Produktseite (getMaxQty), GradedGuard
     kartenPreis                  Kartensuche, Sparkline-Tooltip
     zahlCH                       Trefferzahlen der Kartensuche
     suchbar                      Mindestlaenge der Kartensuche (seit 2026-10-06)
     lagerText                    Lager-Indikator Produktseite, GradedGuard,
                                  Lagerzeile der Warenkorbseite (cart-page.js,
                                  seit 2026-10-21); Liquid-Zwilling im
                                  Karten-Tooltip (SYNC lager-text)
     jmDatum                      Judge.me-Datum Produktseite + /pages/bewertungen
     liefertermin, lieferAussage  Liefertermin der Produktseite, des
                                  Verfuegbarkeits-Tooltips der Produktkarte
                                  (theme.js, seit 2026-10-17) und der Lieferzeile
                                  unter dem Titel von /cart (cart-page.js, seit
                                  2026-10-21)
     lieferDatumText              Zeitwort + Datum dieser /cart-Lieferzeile
                                  («Übermorgen, 23.10.2026», seit 2026-10-21)
     tageBis, abstandArt,         «in N Tagen» im Convention-Kalender (Hero)
     abstandText                  und im Sammler-Kalender der Startseite
                                  (seit 2026-10-08)
   Die Characterization-Tests aus M0 (2026-10-04) pinnen weiter das
   Verhalten; scripts/unit/hdk-util-aufrufer.test.js sichert, dass die
   Module keine Inline-Kopie mehr tragen. Liquid-Zwillinge (gleiche Regel
   serverseitig) tragen SYNC-Marker, die Gate (j) vergleicht.

   WARUM AUSGELAGERT (Audit 2026-09-02, TEST-4): Die Dealeasy-Bridge
   in product-page.js ist laut docs/vendor-kopplungen.md der
   «gefaehrlichste Punkt» der ganzen Vendor-Kopplung — tierMinQty()
   faellt bei einem unerwarteten Mengen-Text STILL auf 1 zurueck, und
   nichts protokolliert das. Solange die Funktion in einer Closure
   hinter `if (dealeasyRoot && qtyInput)` sass, war sie nur mit
   laufender Storefront + Vendor-Widget pruefbar. Hier ist sie mit
   den echten Kachel-Texten in Millisekunden gegen Randfaelle
   abzusichern — und scripts/vendor-smoke.js prueft im gerenderten
   DOM nachweislich DIESELBE Funktion statt einer Kopie, die
   auseinanderlaufen kann.

   LADEREIHENFOLGE: als ERSTES Theme-Asset in layout/theme.liquid
   eingebunden. Alle Theme-Skripte tragen `defer`, laufen also in
   Dokumentreihenfolge vor DOMContentLoaded — window.hdk steht damit
   garantiert, bevor product-page.js / search-suggest.js es lesen.

   ERWEITERN: nur um Funktionen, die tatsaechlich rein sind (gleiche
   Eingabe -> gleiche Ausgabe, keine Seiteneffekte). Alles, was ein
   Element, `window` oder einen Fetch braucht, bleibt in seinem
   Modul — sonst ist die Datei in einer Woche wieder ein Grab-Bag,
   das ohne Browser nicht mehr laeuft.
   ============================================================ */

'use strict';

// Betriebsdaten der Liefertermin-Schaetzung — die EINZIGEN Nicht-Funktionen
// dieser Datei (seit 2026-10-17; vorher in product-page.js, seit der Karten-
// Tooltip in theme.js dieselbe Aussage braucht, liegen sie beim gemeinsamen
// Rechner). Bestellschluss-Aenderung: Checkliste docs/betrieb.md §13.
// Historie: 15 -> 16 Uhr am 2026-08-18, zurueck auf 15 Uhr am 2026-09-11.
var LIEFER_CUTOFF_STUNDE = 15;
// Feiertage (weder Versand noch Zustellung) — JAEHRLICH NACHFUEHREN (Skill
// shopify-tcg-theme, «Liefertermin»; der Kalender-Ablauf-Test in
// scripts/unit/hdk-util-characterization.test.js liest diese Liste und wird rot,
// sobald sie nicht bis heute + 365 Tage reicht). CH-Set: Neujahr, Berchtoldstag,
// Karfreitag, Ostermontag, Auffahrt, Pfingstmontag, 1. August, Weihnachten, Stephanstag.
var LIEFER_FEIERTAGE = [
  '2026-01-01', '2026-01-02', '2026-04-03', '2026-04-06', '2026-05-14',
  '2026-05-25', '2026-08-01', '2026-12-25', '2026-12-26',
  '2027-01-01', '2027-01-02', '2027-03-26', '2027-03-29', '2027-05-06',
  '2027-05-17', '2027-08-01', '2027-12-25', '2027-12-26',
];

var hdk = {

  /* ---------------------------------------------------------
     Dealeasy (Mengenrabatte) — beide Funktionen bekommen TEXT,
     nicht das Element: die DOM-Abfrage bleibt beim Aufrufer, die
     Auswertung ist damit ohne Browser pruefbar (und der
     Smoke-Test kann sie am gerenderten Vendor-Markup fuettern).
     --------------------------------------------------------- */

  /**
   * Mindestmenge einer Rabattstufe = erste Zahl im Mengen-Text.
   * «1 - 3 Stück» -> 1 · «4+ Stück» -> 4 · «Kaufe 10 - 19» -> 10
   *
   * Bewusst textbasiert: Dealeasys `min`-Attribut haengt nur an der
   * AKTIVEN Stufe, ist als Quelle also unbrauchbar. Sprachunabhaengig,
   * weil nur die Ziffern zaehlen.
   *
   * ACHTUNG, der stille Fallback: findet der Regex keine Zahl, gilt
   * die Stufe als «ab 1 Stück» — Klick auf «10+» setzt die Menge auf 1,
   * keine Stufe wird gesperrt, der Rabatt greift nicht, und es gibt
   * keinerlei Fehlermeldung. Genau darauf zielt der Check «Dealeasy
   * tierMinQty der 2. Kachel > 1» in scripts/vendor-smoke.js.
   *
   * Grenze (dokumentiert, nicht behoben): das Vorzeichen wird
   * ignoriert («-5 Stück» -> 5). Dealeasy liefert keine negativen
   * Mengen; ein Guard hier wuerde nur eine Fehlerklasse vortaeuschen,
   * die es nicht gibt.
   */
  tierMinQty: function (text) {
    var m = (text || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 1;
  },

  /**
   * Betrag aus einem Dealeasy-Preistext ziehen — fuer die Umrechnung
   * von Festbetrag-Rabatten in Prozent (relabelTierTexts).
   * «CHF 10.90» -> 10.9 · «CHF 1'299.00» -> 1299 · «Fr. 3,90» -> 3.9
   *
   * Der Strip entfernt Schweizer Tausender-Apostrophe (gerade UND
   * typografisch) sowie jede Art Leerraum inkl. NBSP — Dealeasy setzt
   * je nach Waehrungsformat mal das eine, mal das andere. Das Komma
   * wird als Dezimaltrenner akzeptiert.
   *
   * NaN ist ein gueltiges Ergebnis und der gewollte Weg: der Aufrufer
   * prueft `o > 0 && d >= 0 && d < o`, jeder NaN-Vergleich ist false,
   * die Kachel bleibt damit unangetastet statt falsch beschriftet.
   *
   * Grenze (dokumentiert): ein Punkt als Tausendertrenner («1.299,00»)
   * wuerde als Dezimalpunkt gelesen -> 1.299. In der Schweizer
   * Storefront tritt das Format nicht auf; ein Umschalten der Heuristik
   * waere ohne Waehrungskontext nur geraten.
   */
  parseTierMoney: function (text) {
    var m = (text || '').replace(/['’\s\u00a0]/g, '').match(/\d+(?:[.,]\d+)?/);
    return m ? parseFloat(m[0].replace(',', '.')) : NaN;
  },

  /* ---------------------------------------------------------
     Preisformate — ZWEI Funktionen, kein Versehen.
     Geprueft 2026-09-02 (Audit TEST-4): die beiden bisherigen
     Inline-Fassungen (`fmt` in product-page.js, `formatMoney` in
     search-suggest.js) sind NICHT identisch, und zwar in zwei
     Punkten:

       1. EINHEIT — `fmt` bekommt Rappen aus cart.total_price
          (Shopify-Geldwerte sind ganzzahlige Rappen) und teilt
          durch 100; `formatMoney` bekommt aus
          /search/suggest.json bereits Franken.
       2. TRENNZEICHEN — `fmt` setzt ein geschuetztes Leerzeichen
          (U+00A0), damit «CHF 12.40» im Fliesstext des
          Versandfortschritts nicht umbricht; `formatMoney` ein
          normales, weil der Preis in der Vorschlagsliste allein
          in seinem eigenen <p> steht.

     Zusammenlegen hiesse also, an einer der beiden Stellen das
     Verhalten zu aendern. Beide bleiben, der Unterschied steht
     hier statt in zwei Closures.

     Kein Tausendertrennzeichen (weder ' noch ’): das war schon
     vorher so. CHF 1000+ kann in der Vorschlagsliste vorkommen und
     erscheint dann als «CHF 1299.00». Bewusst nicht mitgeaendert —
     das waere eine sichtbare Aenderung und gehoert Cyre vorgelegt,
     nicht in eine Refactoring-Auslagerung geschmuggelt.
     --------------------------------------------------------- */

  /**
   * Rappen -> «CHF 12.40» mit geschuetztem Leerzeichen.
   * Quelle: `fmt` aus assets/product-page.js (Versandfortschritt).
   */
  chfAusRappen: function (rappen) {
    return 'CHF\u00a0' + (rappen / 100).toFixed(2);
  },

  /**
   * Franken -> «CHF 12.40» mit normalem Leerzeichen.
   * Quelle: `formatMoney` aus assets/search-suggest.js (Suchvorschlaege).
   * parseFloat bleibt drin: suggest.json liefert den Preis je nach
   * Shopify-Version als Zahl ODER als String.
   */
  chfAusFranken: function (franken) {
    return 'CHF ' + parseFloat(franken).toFixed(2);
  },

  /**
   * Externe Strings (Nutzereingabe, API-Daten) vor innerHTML-Einsatz
   * escapen — sonst bricht ein Titel mit <, & oder Anfuehrungszeichen
   * das Markup (Self-XSS).
   *
   * Einmaliger Durchlauf ueber die Zeichenklasse, KEIN kaskadierendes
   * Ersetzen: «&amp;» wird zu «&amp;amp;» und nicht doppelt behandelt.
   * `?? ''` faengt null/undefined ab (0 und '' bleiben erhalten).
   */
  escapeHTML: function (value) {
    return String(value ?? '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  },

  /* =========================================================
     CHARACTERIZATION (Audit 2026-10-02, Milestone 0 Task 0.5)
     Die folgenden Funktionen waren bis M2 Inline-Regeln der
     Module (Herkunft je Funktion). Seit Milestone 2 Block A
     (2026-10-05) rufen die Module sie auf; die Tests in
     scripts/unit/hdk-util-characterization.test.js pinnen das
     Verhalten weiter, einschliesslich bekannter Schwaechen
     («pinnt Ist-Zustand»): wer hier etwas aendert, sieht einen
     roten Test und entscheidet bewusst.
     ========================================================= */

  /**
   * Versandbalken der Produktseite: Fuellstand, In-Bar-Text, Erfolgszustand.
   * Aufrufer: renderShippingProgress() und Sticky-Leiste in assets/product-page.js,
   * Versandbalken in assets/gradedguard.js. Liquid-Zwilling fuer Drawer und /cart:
   * snippets/shipping-progress.liquid (SYNC versand-stand). Absolutes Format
   * «CHF 45.20 / 69.00» seit 2026-09-12, Erfolgszustand ab rest <= 0.
   * `textErreicht` = der lokalisierte Kurztext (themeStrings.shippingFreeShort)
   * — bleibt Parameter, damit die Funktion rein ist.
   * Schwaeche (pinnt Ist-Zustand, Aenderung in M1/M2): Grenze 0 ergibt
   * bei Total 0 pct = NaN (0/0); der Aufrufer faengt 0 heute per `|| 6900` ab.
   */
  /* SYNC(versand-stand) — Liquid-Zwilling: In-Bar-Text in snippets/shipping-progress.liquid (Gate j) */
  versandStand: function (totalRappen, grenzeRappen, textErreicht) {
    var rest = grenzeRappen - totalRappen;
    var pct = Math.max(0, Math.min(100, totalRappen / grenzeRappen * 100));
    var erreicht = rest <= 0;
    return {
      pct: pct,
      rest: rest,
      erreicht: erreicht,
      text: erreicht ? (textErreicht == null ? '' : textErreicht)
        : hdk.chfAusRappen(totalRappen) + ' / ' + (grenzeRappen / 100).toFixed(2)
    };
  },
  /* ENDSYNC(versand-stand) */

  /**
   * Versandkosten nach Warenkorb-Formel (Gewichtsband + Gratisgrenze).
   * Liquid-Zwilling: snippets/shipping-rate.liquid (einziger Liquid-Definierer
   * seit 2026-10-05, Server-Wahrheit fuer Drawer, /cart, JSON-LD, Feed; Audit:
   * = shipping_rates.json in 8 Grenzfaellen; SYNC versand-band, Gate (j)). Default-Tarif =
   * Theme-Settings (settings_schema.json): Gratis ab CHF 69, Paket 9.00,
   * Grossbrief bis 500 g 3.90, Kleinbrief bis 235 g 1.90. Grenzen inklusive
   * (235 g = Kleinbrief, 236 g = Grossbrief, 500 g = Grossbrief, 501 g = Paket).
   * `methode` = Locale-Schluessel-Suffix (shipping.method_<methode>).
   *
   * Aufrufer seit 2026-10-04 (Audit M1): assets/gradedguard.js shipping() fuer
   * die Versandvorschau auf Cart + Auswahl; dort bleibt nur «nichts im Cart und
   * nichts gewaehlt -> 0» als eigene Regel. Die fruehere GG-Abweichung bei
   * Grenze 0 (GG nie gratis, Liquid immer) ist damit aufgeloest.
   */
  /* SYNC(versand-band) — Liquid-Zwilling: snippets/shipping-rate.liquid (Gate j) */
  versandBand: function (gewichtGramm, totalRappen, tarif) {
    var t = tarif || {};
    var grenze = t.grenze == null ? 6900 : t.grenze;
    var rappen = t.paket == null ? 900 : t.paket;
    var methode = 'parcel';
    if (gewichtGramm <= (t.briefLimit == null ? 500 : t.briefLimit)) {
      rappen = t.brief == null ? 390 : t.brief;
      methode = 'letter_xl';
    }
    if (gewichtGramm <= (t.kleinLimit == null ? 235 : t.kleinLimit)) {
      rappen = t.kleinbrief == null ? 190 : t.kleinbrief;
      methode = 'letter';
    }
    if (totalRappen >= grenze) rappen = 0;
    return { rappen: rappen, methode: methode };
  },
  /* ENDSYNC(versand-band) */

  /**
   * Kaufbare Menge einer Variante (Deckel fuer Stepper, Staffel-Sperre, ATC).
   * Aufrufer: getMaxQty() in assets/product-page.js (seit 2026-10-05) und die
   * GradedGuard-Stepper.
   *   verfuegbar === false (Shopify: nicht kaufbar) -> 0
   *   bestand keine Zahl oder <= 0 (ungetrackt/Ueberverkauf) -> unbegrenzt
   *   sonst bestand - imCart; max_bestellmenge (> 0) deckelt zusaetzlich
   *   abzueglich imCart; Ergebnis nie negativ.
   * Schwaeche (pinnt Ist-Zustand): ein getrackter Bestand <= 0 bei erlaubtem
   * Ueberverkauf gilt als unbegrenzt — gewollt, aber nur hier ablesbar.
   * GG (gradedguard.js kaufbar) ruft die Funktion seit 2026-10-04 mit der
   * Cart-Menge aus /cart.js auf (CQ-3, Audit M1), Deckel 99 fuer Ungetrackte.
   */
  kaufbareMenge: function (bestand, imCart, maxBestellung, verfuegbar) {
    if (verfuegbar === false) return 0;
    var drin = imCart || 0;
    var rest = (typeof bestand !== 'number' || bestand <= 0) ? Infinity : bestand - drin;
    if (typeof maxBestellung === 'number' && maxBestellung > 0) {
      rest = Math.min(rest, maxBestellung - drin);
    }
    return rest > 0 ? rest : 0;
  },

  /**
   * Getippte Menge in einem Warenkorb-Mengenfeld pruefen — EINE Regel fuer
   * Cart-Drawer (cart-drawer.js) und /cart (cart-page.js).
   * `raw` = input.value, `serverWert` = gerenderter Wert (input.defaultValue),
   * `max` = data-max («0»/leer = keine Grenze).
   * Policy seit 2026-10-04 (Audit ROB-15, Owner-Entscheid Frage 4): angenommen
   * wird nach Trim NUR eine reine Ziffernfolge (`^\d+$`, ASCII). Alles andere —
   * leer, «1.5», «3abc», «-1», «+2», «1e2» — ist ungueltig: Feld zurueck auf den
   * Server-Wert, KEIN Request (vorher schnitt parseInt still ab: «1.5» -> 1,
   * «3abc» -> 3). «0» bleibt gueltig und heisst «Zeile entfernen». Ueber `max`
   * wird auf `max` geklemmt (`clamped`, der Aufrufer zeigt «Maximale
   * Bestellmenge erreicht»).
   */
  normalizeQty: function (raw, serverWert, max) {
    var text = String(raw == null ? '' : raw).trim();
    if (!/^\d+$/.test(text)) return { value: serverWert, invalid: true, clamped: false };
    var parsed = parseInt(text, 10);
    var grenze = parseInt(max || '0', 10);
    if (grenze > 0 && parsed > grenze) return { value: grenze, invalid: false, clamped: true };
    return { value: parsed, invalid: false, clamped: false };
  },

  /**
   * Staffelstufe fuer eine Stueckzahl (GradedGuard Mix & Match).
   * Quelle und Aufrufer: assets/gradedguard.js (seit 2026-10-04) — Stufen ohne Preis
   * fallen raus, die hoechste erreichte Mindestmenge gewinnt, unterhalb der
   * ersten Stufe (auch bei 0 Stueck) gilt die erste.
   * Schwaeche (pinnt Ist-Zustand): ohne gueltige Stufe -> undefined.
   */
  tierFor: function (menge, tiers) {
    var gueltig = (tiers || []).filter(function (t) { return t.price > 0; })
      .sort(function (a, b) { return a.min - b.min; });
    return gueltig.filter(function (t) { return menge >= t.min; })
      .sort(function (a, b) { return b.min - a.min; })[0] || gueltig[0];
  },

  /**
   * Marktpreis der Kartenliste: «€1'829.68» — Praefix-Symbol, Tausender-
   * Apostroph, immer zwei Nachkommastellen.
   * Aufrufer (seit 2026-10-05): Treffer-Kacheln in assets/kartensuche.js und der
   * Sparkline-Tooltip (snippets/pokemon-sparkline.liquid). Liquid-Zwilling
   * snippets/pokemon-preis.liquid (`times: 100 | round`, `modulo`, `divided_by` —
   * rechnet ebenfalls in ganzen Cents; SYNC karten-preis, Gate (j)).
   * Schwaeche (pinnt Ist-Zustand): negative Werte ergeben Unsinn
   * («€-1.-5»); Kartenpreise sind nie negativ.
   */
  /* SYNC(karten-preis) — Liquid-Zwilling: snippets/pokemon-preis.liquid (Gate j) */
  kartenPreis: function (wert, waehrung) {
    var cents = Math.round(wert * 100);
    var rest = ('0' + (cents % 100)).slice(-2);
    var ganz = String(Math.floor(cents / 100));
    var gruppen = '';
    while (ganz.length > 3) {
      gruppen = "'" + ganz.slice(-3) + gruppen;
      ganz = ganz.slice(0, -3);
    }
    return waehrung + ganz + gruppen + '.' + rest;
  },
  /* ENDSYNC(karten-preis) */

  /**
   * Ganzzahl im Schweizer Zahlensatz: 21234 -> «21'234» (Tausender-Apostroph,
   * keine Nachkommastellen, keine Einheit). Aufrufer (seit 2026-10-06, Audit
   * 2026-10 ROB-16): Trefferzahlen der Kartensuche (assets/kartensuche.js,
   * Platzhalter __N__/__TOTAL__). Liquid-Zwilling snippets/pokemon-zahl.liquid
   * (SYNC zahl-ch, Gate j); der deckelt bei 12 Stellen (Liquid kennt kein while),
   * hier gibt es keinen Deckel — beides weit ueber jedem realen Wert.
   * Schwaeche (pinnt Ist-Zustand): nur fuer nicht-negative Ganzzahlen gedacht;
   * ein Vorzeichen wird wie eine Ziffer mitgezaehlt (-123456 -> «-'123'456»).
   */
  /* SYNC(zahl-ch) — Liquid-Zwilling: snippets/pokemon-zahl.liquid (Gate j) */
  zahlCH: function (n) {
    var ganz = String(n);
    var gruppen = '';
    while (ganz.length > 3) {
      gruppen = "'" + ganz.slice(-3) + gruppen;
      ganz = ganz.slice(0, -3);
    }
    return ganz + gruppen;
  },
  /* ENDSYNC(zahl-ch) */

  /**
   * Ist eine Kartensuche lang genug, um zu suchen? Bekommt die NORMALISIERTEN
   * Tokens (norm() in assets/kartensuche.js, Leer-Tokens schon entfernt) und
   * verlangt, dass das LAENGSTE Token `min` Zeichen erreicht.
   *   ['mew'] -> true · ['mr.', 'mime'] -> true · ['a', 'mew'] -> true
   *   ['a', 'b'] -> false · ['x', 'y', 'z'] -> false · [] -> false
   * Warum das laengste Token und nicht die Gesamtlaenge (Audit 2026-10 ROB-16,
   * Ergaenzung 2026-10-06): die Suche verlangt JEDES Token als Teilstring, ein
   * Einzelzeichen-Token filtert darum fast nichts. «a b» bestand die Pruefung
   * ueber tokens.join(' ').length (3 >= 2) und lieferte headless 8'183 Treffer,
   * «x y z» 387 — eine Suche ohne Suchwort. Mit einem tragenden Token («a mew»)
   * bleibt die Eingabe gueltig, die Einzelzeichen schraenken dann nur weiter ein.
   * Aufrufer: anwenden() in assets/kartensuche.js.
   */
  suchbar: function (tokens, min) {
    var laengstes = 0;
    for (var i = 0; i < (tokens || []).length; i++) {
      if (tokens[i].length > laengstes) laengstes = tokens[i].length;
    }
    return laengstes >= min;
  },

  /**
   * Welche Lagertext-Variante gilt? Liefert den Schluessel in
   * window.themeStrings (der Text selbst ist lokalisiert und bleibt beim
   * Aufrufer). Aufrufer: Lager-Indikator und Sticky-Kurztext in
   * assets/product-page.js (Schwellen 10/6, Cyre 2026-08-09), stockText() in
   * assets/gradedguard.js fuer getrackte Varianten und die Lagerzeile der Positionen
   * in assets/cart-page.js (verfuegbarkeit, seit 2026-10-21).
   *   > 10 -> stockMoreThan · 6..10 -> stockCount · < 6 -> stockCountFew
   * Schwaeche (pinnt Ist-Zustand): 0 und negative Bestaende landen bei
   * stockCountFew — die Aufrufer rufen nur mit Bestand > 0.
   */
  lagerText: function (bestand) {
    // SYNC(lager-text): Liquid-Zwilling fuer den Karten-Tooltip in snippets/product-card.liquid; Gate (j)
    if (bestand > 10) return 'stockMoreThan';
    return bestand < 6 ? 'stockCountFew' : 'stockCount';
    // ENDSYNC(lager-text)
  },

  /**
   * Die fertige Lieferaussage («Morgen geliefert» / «Übermorgen …» / «Mo, 10.8.
   * geliefert») fuer einen Zeitpunkt: rechnet den Liefertermin mit den
   * Betriebsdaten oben (LIEFER_CUTOFF_STUNDE, LIEFER_FEIERTAGE) und setzt den
   * passenden Locale-String aus `str` (window.themeStrings: deliveryEstTomorrow,
   * deliveryEstTwoDays, deliveryEstWeekday mit Platzhalter __DAY__). Wochentag
   * nach `lang`; Kurzform ohne Intl-Schlusspunkt («Mo.» -> «Mo»), Datum ungepolstert
   * T.M. (Cyre 2026-08-09). Tagesrechnung DST-frei in UTC wie liefertermin.
   * Aufrufer: updateDeliveryEstimate() in assets/product-page.js, der
   * Verfuegbarkeits-Tooltip der Produktkarte in assets/theme.js (seit 2026-10-17;
   * vorher lag die Formatierung inline in product-page.js) und die Lieferzeile unter
   * dem Titel der Warenkorbseite in assets/cart-page.js (lieferzeile, seit 2026-10-21;
   * sie liest nur versand/lieferung/tage und formatiert mit hdk.lieferDatumText).
   * Rueckgabe: { versand, lieferung, tage, text } — text ist Markup aus den
   * _html-Locale-Strings (innerHTML beim Aufrufer).
   */
  lieferAussage: function (jetzt, lang, str) {
    var termin = hdk.liefertermin(jetzt, LIEFER_CUTOFF_STUNDE, LIEFER_FEIERTAGE);
    var datum = new Date(termin.lieferung + 'T00:00:00Z');
    var sprache = lang || 'de';
    var wochentag = new Intl.DateTimeFormat(sprache, { weekday: 'long', timeZone: 'UTC' }).format(datum);
    var wdKurz = new Intl.DateTimeFormat(sprache, { weekday: 'short', timeZone: 'UTC' })
      .format(datum).replace(/\.$/, '');
    var datumKurz = wdKurz + ', ' + datum.getUTCDate() + '.' + (datum.getUTCMonth() + 1) + '.';
    var text = termin.tage === 1
      ? str.deliveryEstTomorrow
      : termin.tage === 2
        ? str.deliveryEstTwoDays.replace('__DAY__', wochentag)
        : str.deliveryEstWeekday.replace('__DAY__', datumKurz);
    return { versand: termin.versand, lieferung: termin.lieferung, tage: termin.tage, text: text };
  },

  /**
   * Zeitwort + Datum des erwarteten Liefertermins fuer die Lieferzeile unter dem
   * Titel der Warenkorbseite: «Morgen, 22.10.2026» / «Übermorgen, 23.10.2026» /
   * «Montag, 26.10.2026». Eingabe ist das Ergebnis von hdk.lieferAussage (lieferung
   * als ISO-Datum, tage = Kalendertage bis dahin; die Regel bleibt dort):
   *   1 Tag   -> str.deliveryWhenTomorrow
   *   2 Tage  -> str.deliveryWhenTwoDays — darf den Platzhalter __DAY__ tragen und
   *              nennt dann den Wochentag (EN, wie product.delivery_est_two_days_html)
   *   sonst   -> Wochentag ausgeschrieben nach `lang` (Intl, weekday long)
   * Fehlt das Wort in `str`, gilt der Wochentag. Datum TT.MM.JJJJ in beiden Sprachen
   * (Hauskonvention, docs/i18n-glossar.md). Ungueltige Eingabe -> '' (der Aufrufer
   * zeigt dann keine Zeile). Tagesrechnung in UTC wie lieferAussage.
   * Aufrufer: lieferzeile() in assets/cart-page.js (seit 2026-10-21).
   */
  lieferDatumText: function (aussage, lang, str) {
    var a = aussage || {};
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(a.lieferung == null ? '' : a.lieferung));
    if (!m) return '';
    var s = str || {};
    var wochentag = new Intl.DateTimeFormat(lang || 'de', { weekday: 'long', timeZone: 'UTC' })
      .format(new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])));
    var wort = a.tage === 1 ? s.deliveryWhenTomorrow : a.tage === 2 ? s.deliveryWhenTwoDays : '';
    wort = wort ? wort.replace('__DAY__', wochentag) : wochentag;
    return wort + ', ' + m[3] + '.' + m[2] + '.' + m[1];
  },

  /**
   * Judge.me-Datum auf Hauskonvention TT.MM.JJJJ. Liefert den neuen Text
   * oder null (= nicht anfassen; der Aufrufer schreibt nur bei Aenderung,
   * sonst feuert der MutationObserver im Kreis).
   * Aufrufer: fixDates() in assets/product-page.js und assets/reviews-page.js
   * (vorher zwei Inline-Klone, CQ-6; Anker VENDOR:jm-datum).
   * Schwaeche (pinnt Ist-Zustand): nur exakt zweistellige Tage/Monate.
   */
  jmDatum: function (text) {
    var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(text == null ? '' : text).trim());
    return m ? m[1] + '.' + m[2] + '.' + m[3] : null;
  },

  /**
   * Liefertermin-Schaetzung nach Shop-Zeit (Europe/Zurich): Versandtag =
   * heute, wenn Werktag und vor `cutoffStunde`, sonst naechster Werktag;
   * Liefertag = naechster Werktag nach dem Versandtag. Werktag = Mo–Fr und
   * nicht in `feiertage` (ISO-Daten).
   * Aufrufer: hdk.lieferAussage (unten), die Cutoff und Feiertagsliste aus den
   * Betriebsdaten am Dateikopf uebergibt (LIEFER_CUTOFF_STUNDE, LIEFER_FEIERTAGE);
   * der Kalender-Ablauf-Test liest die Liste von dort und prueft ihre Reichweite.
   * Rueckgabe: { versand, lieferung } als ISO-Datum, `tage` = Kalendertage
   * von heute bis zur Lieferung (1 -> «Morgen», 2 -> «Übermorgen»).
   */
  liefertermin: function (jetzt, cutoffStunde, feiertage) {
    var teile = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(jetzt).reduce(function (acc, p) { acc[p.type] = p.value; return acc; }, {});
    var heute = Date.UTC(+teile.year, +teile.month - 1, +teile.day);
    var sekunden = +teile.hour * 3600 + +teile.minute * 60 + +teile.second;
    var TAG = 86400000;
    var iso = function (t) { return new Date(t).toISOString().slice(0, 10); };
    var liste = feiertage || [];
    var werktag = function (t) {
      var d = new Date(t).getUTCDay();
      return d >= 1 && d <= 5 && liste.indexOf(iso(t)) === -1;
    };
    var versand = heute;
    if (!(werktag(heute) && sekunden < cutoffStunde * 3600)) {
      do { versand += TAG; } while (!werktag(versand));
    }
    var lieferung = versand + TAG;
    while (!werktag(lieferung)) lieferung += TAG;
    return { versand: iso(versand), lieferung: iso(lieferung), tage: Math.round((lieferung - heute) / TAG) };
  },

  /**
   * Kalendertage von heute (Shop-Zeit Europe/Zurich, Kalendertag von `jetzt`)
   * bis zum ISO-Datum `isoDatum` (YYYY-MM-DD): Mitternacht-zu-Mitternacht,
   * gerundet — Sommerzeit-Tage mit 23/25 Stunden springen nicht. 0 = heute,
   * 1 = morgen, negativ = vorbei. Ungueltige Eingabe -> null (der Aufrufer
   * laesst dann den Servertext stehen).
   * Dieselbe Rechnung macht Liquid serverseitig ('now' | date: '%Y-%m-%d' |
   * date: '%s', Differenz / 86400.0 | round; convention-hero,
   * sammler-kalender-termin); das JS rechnet sie nach, weil das HTML im
   * CDN-Cache liegt und «heute» nur vom Render kennt (docs/patterns.md
   * «Zeitabhaengige Anzeige»).
   * Aufrufer: Countdown im Hero von assets/convention-kalender.js und im
   * Terminband von sections/sammler-kalender.liquid (javascript-Block).
   * `jetzt` wird uebergeben (Aufrufer: new Date()), damit die Funktion rein
   * und testbar bleibt.
   */
  tageBis: function (isoDatum, jetzt) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(isoDatum == null ? '' : isoDatum));
    if (!m || !(jetzt instanceof Date) || isNaN(jetzt.getTime())) return null;
    var teile = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(jetzt).reduce(function (acc, p) { acc[p.type] = p.value; return acc; }, {});
    var heute = Date.UTC(+teile.year, +teile.month - 1, +teile.day);
    var ziel = Date.UTC(+m[1], +m[2] - 1, +m[3]);
    return Math.round((ziel - heute) / 86400000);
  },

  /**
   * Welcher Abstandstext gilt: 'heute' (0), 'morgen' (1), 'tage' (> 1, «in N
   * Tagen»), 'laeuft' (Start vorbei, Ende nicht: mehrtaegiger Termin) oder null
   * (vorbei bzw. ungueltig — der Aufrufer laesst den Servertext stehen statt zu
   * raten). Eingaben sind Ergebnisse von tageBis fuer Start und Ende (Ende
   * fehlt -> wie Start). Liquid-Zwilling: die if/elsif-Kette in
   * snippets/convention-hero.liquid und snippets/sammler-kalender-termin.liquid.
   * Aufrufer: wie tageBis.
   */
  abstandArt: function (tageStart, tageEnde) {
    if (typeof tageStart !== 'number' || isNaN(tageStart)) return null;
    if (tageStart < 0) {
      var ende = typeof tageEnde === 'number' && !isNaN(tageEnde) ? tageEnde : tageStart;
      return ende >= 0 ? 'laeuft' : null;
    }
    if (tageStart === 0) return 'heute';
    return tageStart === 1 ? 'morgen' : 'tage';
  },

  /**
   * Der fertige Abstandstext eines Countdown-Elements aus seinen data-Attributen
   * (Vertrag: data-start, data-end, data-t-days mit Platzhalter __N__, data-t-one,
   * data-t-today, data-t-running — Aufrufer reichen `element.dataset`). Liefert
   * den Text oder null (vorbei/ungueltig: Servertext stehen lassen).
   * Aufrufer: wie tageBis; beide schreiben nur bei Aenderung per textContent.
   */
  abstandText: function (daten, jetzt) {
    var d = daten || {};
    var tage = hdk.tageBis(d.start, jetzt);
    var art = hdk.abstandArt(tage, hdk.tageBis(d.end || d.start, jetzt));
    if (art === 'laeuft') return d.tRunning || null;
    if (art === 'heute') return d.tToday || null;
    if (art === 'morgen') return d.tOne || null;
    if (art === 'tage' && d.tDays) return d.tDays.replace('__N__', String(tage));
    return null;
  }
};

// Browser: window.hdk. In `node --test` gibt es kein window — die Zuweisung
// wird uebersprungen, der Export unten liefert dasselbe Objekt.
if (typeof window !== 'undefined') window.hdk = hdk;
if (typeof module !== 'undefined' && module.exports) module.exports = hdk;
